var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2369 15.1156C19.0482 14.3832 19.7135 13.6416 20.1878 13.0657C20.576 12.5944 20.77 12.3588 20.77 12C20.77 11.6412 20.576 11.4056 20.1878 10.9343C18.7677 9.21014 15.6355 6 11.9998 6C11.1603 6 10.3478 6.17112 9.57689 6.45557L12.1238 9.00252C13.682 9.06591 14.9339 10.3178 14.9972 11.8759L18.2369 15.1156ZM9.39292 10.5142C9.14274 10.9523 8.99977 11.4594 8.99977 12C8.99977 13.6569 10.3429 15 11.9998 15C12.5403 15 13.0475 14.857 13.4855 14.6068L15.7871 16.9084C14.6359 17.5555 13.3527 18 11.9998 18C8.36403 18 5.23183 14.7899 3.81173 13.0657C3.42357 12.5944 3.22949 12.3588 3.22949 12C3.22949 11.6412 3.42357 11.4056 3.81174 10.9343C4.48518 10.1166 5.54368 8.96481 6.85832 7.97964L9.39292 10.5142Z",
    fill: "#29363D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 2L21 18",
    stroke: "#29363D",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.330886b19e4844e8d11bfe5673424d22.svg";
export { ForwardRef as ReactComponent };